var _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-8.5 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.819 6.034h1.049v4.196h-1.049v-4.196z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.686 9.181c0-4.056-3.288-7.343-7.343-7.343-4.056 0-7.343 3.287-7.343 7.343 0 3.123 1.954 5.785 4.704 6.846v14.134h5.245v-3.655l1.59-1.59-1.59-1.59v-2.065l2.639-2.639-2.598-2.598c2.745-1.063 4.696-3.723 4.696-6.843zM9.611 15.046l-0.711 0.275v1.097l2.203 2.205-2.204 2.204v2.934l1.155 1.156-1.155 1.156v3.041h-3.147v-13.805l-0.672-0.259c-2.449-0.945-4.032-3.247-4.032-5.867 0-3.471 2.823-6.294 6.294-6.294 3.47 0 6.294 2.823 6.294 6.294-0 2.616-1.581 4.918-4.026 5.865z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.a478d655a0d2e801e4cb9554d0deba7a.svg";
export { ForwardRef as ReactComponent };